import BreadCrumb from "../screens/Common/BreadCrumb";
import React from "react";

import LayoutContainer from "../screens/layout/admin-dashboard";
import CategoryAttachmentList from "../screens/CategoryInfoView/CategoryList";

const breadCrumbData = [{ link: "/category-info-attachment-list", name: "Document Search" }];
const CategoryManagement = () => (
  <>
    <LayoutContainer>
      <BreadCrumb data={breadCrumbData} />
      <CategoryAttachmentList />
    </LayoutContainer>
  </>
);

export default CategoryManagement;